import { get } from '../utils/api';

class StateAffordableProgramConfigService {
  getAll(programName, state, options?: Object) {
    const queryParams = new URLSearchParams({
      state,
      programName,
    });
    return get(`/stateAffordableProgramConfig?${queryParams}`, options);
  }
  determineHotmaStatus({ state, programName, effectiveDate, options = {} }) {
    if (!state || !programName || !effectiveDate) {
      throw new Error(
        'StateAffordableProgramConfigService.determineHotmaStatus: state, programName, and effectiveDate are required',
      );
    }
    const queryParams = new URLSearchParams({
      state,
      programName,
      effectiveDate,
    });
    return get(
      '/stateAffordableProgramConfig/determineHotmaStatus?' + queryParams,
      options,
    );
  }
  getAllByPropertyId(propertyId: string, options?: Object) {
    return get(`/stateAffordableProgramConfig/property/${propertyId}`, options);
  }
}

export default StateAffordableProgramConfigService;
